var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5405 1.33848C12.7138 0.934734 13.2862 0.934732 13.4595 1.33849L16.3526 8.07988C16.5696 8.58566 17.0463 8.93195 17.5944 8.98209L24.8998 9.65039C25.3374 9.69042 25.5142 10.2348 25.1838 10.5244L19.6664 15.3591C19.2524 15.7218 19.0704 16.2821 19.1921 16.8189L20.814 23.9733C20.9111 24.4018 20.448 24.7382 20.0705 24.5135L13.7675 20.7601C13.2946 20.4785 12.7054 20.4785 12.2325 20.7601L5.92947 24.5135C5.55197 24.7382 5.08889 24.4018 5.18603 23.9733L6.80795 16.8189C6.92963 16.2821 6.74758 15.7218 6.33363 15.3591L0.816197 10.5244C0.485752 10.2348 0.662633 9.69042 1.10017 9.65039L8.40564 8.98209C8.95374 8.93195 9.43036 8.58566 9.64742 8.07988L12.5405 1.33848Z",
    fill: "#F7C604",
    stroke: "#F7C604"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.151867309c65515fb478148135e8b40b.svg";
export { ForwardRef as ReactComponent };